/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createReorderFulfillmentMethodsResponseFromDiscriminatorValue, serializeReorderFulfillmentMethodsRequest, serializeReorderFulfillmentMethodsResponse, type ErrorResponse, type ReorderFulfillmentMethodsRequest, type ReorderFulfillmentMethodsResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/fulfillment-methods/reorder
 */
export interface ReorderRequestBuilder extends BaseRequestBuilder<ReorderRequestBuilder> {
    /**
     * Rearranges the organization's fulfillment methods. Position is meaningful: the first item is what the sales app seeds onto a new cart when the customer has no default of their own. Send every existing method exactly once, in the new order — adding, dropping, or repeating one is a 400. Values match case-insensitively and the casing on file is kept.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ReorderFulfillmentMethodsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     */
     put(body: ReorderFulfillmentMethodsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ReorderFulfillmentMethodsResponse | undefined>;
    /**
     * Rearranges the organization's fulfillment methods. Position is meaningful: the first item is what the sales app seeds onto a new cart when the customer has no default of their own. Send every existing method exactly once, in the new order — adding, dropping, or repeating one is a 400. Values match case-insensitively and the casing on file is kept.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: ReorderFulfillmentMethodsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ReorderRequestBuilderUriTemplate = "{+baseurl}/api/organizations/fulfillment-methods/reorder";
/**
 * Metadata for all the requests in the request builder.
 */
export const ReorderRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: ReorderRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createReorderFulfillmentMethodsResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeReorderFulfillmentMethodsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
